import { render, staticRenderFns } from "./Товарооборот за период.vue?vue&type=template&id=22b70996&scoped=true"
import script from "./Товарооборот за период.vue?vue&type=script&lang=js"
export * from "./Товарооборот за период.vue?vue&type=script&lang=js"
import style0 from "./Товарооборот за период.vue?vue&type=style&index=0&id=22b70996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b70996",
  null
  
)

export default component.exports